module.exports = __webpack_public_path__ + "static/media/logo.de35c8d3.svg";